// extracted by mini-css-extract-plugin
export var errorMessage = "FormNavigationPanel-module__errorMessage___vlakA";
export var navigationPanel = "FormNavigationPanel-module__navigationPanel___Zonfp";
export var saveButtonWrapper = "FormNavigationPanel-module__saveButtonWrapper___i-E-j";
export var spinnerWrapper = "FormNavigationPanel-module__spinnerWrapper___+G4F7";